import { createContext } from 'react';
import { UseDisclosureResult } from '../../../lib/hooks';
import { CredentialTaskDto } from '../../../api/app.types';

export const TaskDetailPanelContext = createContext<UseDisclosureResult<CredentialTaskDto> | undefined>(undefined);
